module.exports = __webpack_public_path__ + "img/member-manage.d3a64201.svg";